import { useNavigate } from "react-router-dom";

import { useAuth } from "../../services/authentication/authentication.context";
import "../../styles/account.css";
import { DataUnit } from "../../components/page/myaccount/data-unit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { formatUrl } from "../../_helpers/parseurl";
import { AppHeader } from "../../components/header/header";

export const UserAccount = () => {

    const { user } = useAuth();

    const navigateTo = useNavigate();

    return (
        <div className="full-v">
            <AppHeader />
            <div className="account-container">
                <div className="flx-c-rw">
                    <img 
                        className="avatar-frame"  
                        src={formatUrl(user?.avatar)}
                        alt={user?.firsname}
                    />
                    <button className="img-btn" onClick={() => navigateTo("/avatar")}>
                        <FontAwesomeIcon icon={faCamera} />
                    </button>
                </div>
                <div className="sm-sp" />
                <DataUnit caption={"Names"} data={user?.firstname+ " " + user?.lastname}/>
                <DataUnit caption={"Username"} data={user?.username} />
                <DataUnit caption={"Role"} data={user?.role} />
                <DataUnit caption={"Email"} data={user?.email} />
                <div className="sm-sp" />
            </div>
        </div>
    )
}